<app-ace-select
  #aceSelect
  placement="left"
  [items]="contractors"
  [multiSelect]="multiSelect"
  [bindLabel]="'name'"
  [placeholder]="placeholder"
  [loading]="loading"
  [compareWith]="compareFn"
  [hideSelected]="true">

  @if (!multiSelect) {
    <ng-template #labelTemplate let-item="item" let-clear="clear">
      <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
      <span class="ng-value-label" [title]="item.name">{{item.name}}</span>
    </ng-template>
  } @else {
    <ng-template #multiLabelTemplate let-items="items" let-clear="clear">
      @if (items.length <= MAX_ITEMS) {
        <div>
          @for (item of items; track item.id) {
            <div class="ng-value">
              <span class="ng-value-icon left" (click)="clear(item)" aria-hidden="true">×</span>
              <span class="ng-value-label" [title]="item.name">{{item.name}}</span>
            </div>
          }
        </div>
      } @else {
        <div>
          <div class="ng-value">
            <span class="ng-value-label">{{ 'X Contractors Selected' | messageTranslate:{n: items.length} }}</span>
          </div>
        </div>
      }
    </ng-template>
  }

  <ng-template #optionTemplate let-item="item">
    <span class="ng-value-label" [title]="item.name">{{item.name}}</span>
  </ng-template>

</app-ace-select>
